import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/aes/productmaster'
import pathMap from 'src/paths/pathMap'

class AesProductMasterRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.AES_PRODUCT_MASTER_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.AES_PRODUCT_MASTER_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.AES_PRODUCT_MASTER_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.AES_PRODUCT_MASTER_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default AesProductMasterRoute
